import styled from '@emotion/styled'
import { css } from '@emotion/react'

import dottedDarkBg from './../../../assets/images/check-icon.png'
import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'
import { CheckListItemStyleProps } from './types'

const CheckListStyled = styled.ul``

const CheckListItemStyled = styled.li<WithTheme<CheckListItemStyleProps>>`
  position: relative;
  font-size: 0.875rem;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 1.4;

  &:before {
    content: '';
    position: absolute;
    top: 0.25rem;
    width: 0.9375rem;
    height: 0.75rem;
    background-image: url(${dottedDarkBg});
    background-repeat: no-repeat;

    ${({ theme }) =>
      theme.direction === 'rtl'
        ? css`
            right: 0;
          `
        : css`
            left: 0;
          `}
  }
  &:not(:last-of-type) {
    margin-bottom: 1.5rem;
  }

  ${({ theme }) =>
    theme.direction === 'rtl'
      ? css`
          padding-right: 1.5rem;
        `
      : css`
          padding-left: 1.5rem;
        `}

  @media ${media.phone} {
    font-size: 1.0625rem;
  }

  ${({ isAwarded, theme }) =>
    isAwarded &&
    css`
      font-weight: ${theme.fontWeights.bold};
      text-decoration: underline;
    `};
`

export { CheckListStyled, CheckListItemStyled }
